import React from "react";

import SelectList from "../../../../../components/select_list";
import { getText } from "../../../../../helpers";

const TAGS_OPTIONS = [
  { label: "AI translation", value: "ai_translation" },
  { label: "Manual Translation", value: "manual_translation" },
  { label: "Approved", value: "approved" },
];

export default function EditTranslationModalTags(props) {
  const { editedTranslation, onTranslationChange } = props;
  const tag_list = editedTranslation.tag_list || [];

  function onTagsChange(updated_tags, option) {
    let new_tags = [...updated_tags]

    if (option.value === "ai_translation" && updated_tags.find(tag => tag === "manual_translation")) {
      new_tags = updated_tags.filter(tag => tag !== "manual_translation")
    } else if (option.value === "manual_translation" && updated_tags.find(tag => tag === "ai_translation")) {
      new_tags = updated_tags.filter(tag => tag !== "ai_translation")
    }

    onTranslationChange({ target: { name: "tag_list", value: new_tags } });
  }

  function onRemoveTag(value) {
    const updated_tags = tag_list.filter((tag) => value !== tag);
    onTagsChange(updated_tags);
  }

  return (
    <div className="edit-translation-tags">
      <SelectList
        className="me-1"
        header={`${getText("Assign tags")}:`}
        trigger={<span className="link text-light-blue">{getText("Tags")}</span>}
        options={TAGS_OPTIONS}
        selections={tag_list}
        onChange={onTagsChange}
      />
      {tag_list.map((tag) => {
        const option = TAGS_OPTIONS.find(({ value }) => value === tag);

        return (
          <span className="translation-tag" key={tag}>
            <span>{option.label}</span>
            <span>
              <i aria-hidden="true" className="delete icon" onClick={() => onRemoveTag(tag)}></i>
            </span>
          </span>
        );
      })}

    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/edit_translation_modal/edit_translation_modal_tags.js